import {
  USER_INTERFACE_PASSWORD_EYE_SHOW,
  TIME_LOCATION_BED,
  FOOD_BEVERAGE_MEAL_PACKAGE,
  ACTIVITY_POOL,
  ACTIVITY_SPINNING,
  ACTIVITY_SPA,
  TIME_LOCATION_COMBINATION,
  TIME_LOCATION_MAP_ROUTE,
  WEATHER_PARTLY_CLOUDY,
  COMMUNICATION_REVIEW,
  MISC_ENVIRONMENT,
  USER_CHILD,
  MISC_MICROPHONE,
  TIME_LOCATION_MAIN_CENTER,
} from '@bwoty-web/styleguide';

export const sectionKeys = {
  accommodation: 'accommodation',
  foodAndBeverage: 'foodAndBeverage',
  poolAndBeach: 'poolAndBeach',
  sportsRelaxationEntertainment: 'sportsRelaxationEntertainment',
  spa: 'spa',
  kidsFacilities: 'kidsFacilities',
  locationAndTransfer: 'locationAndTransfer',
  rating: 'rating',
  map: 'map',
  weather: 'weather',
  show: 'show',
  sustainability: 'sustainability',
  overview: 'overview',
  aboutHotel: 'aboutHotel',
};

export const sectionIcons = {
  accommodation: TIME_LOCATION_BED,
  foodAndBeverage: FOOD_BEVERAGE_MEAL_PACKAGE,
  poolAndBeach: ACTIVITY_POOL,
  sportsRelaxationEntertainment: ACTIVITY_SPINNING,
  spa: ACTIVITY_SPA,
  kidsFacilities: USER_CHILD,
  locationAndTransfer: TIME_LOCATION_COMBINATION,
  rating: COMMUNICATION_REVIEW,
  map: TIME_LOCATION_MAP_ROUTE,
  weather: WEATHER_PARTLY_CLOUDY,
  show: MISC_MICROPHONE,
  sustainability: MISC_ENVIRONMENT,
  overview: USER_INTERFACE_PASSWORD_EYE_SHOW,
  aboutHotel: TIME_LOCATION_MAIN_CENTER,
};
